export default __webpack_public_path__ + "static/douleur_des_belges-b028aaf8c104b8b5fe62a8e06aea3f65.png";